import { gql, useQuery } from '@apollo/client';
import {
  GetGoogleGroupQuery,
  GetGoogleGroupQueryVariables,
} from '../../../__generated__/queries-auth';

export const GET_GOOGLE_GROUP = gql`
  query GetGoogleGroup($where: GoogleGroupUniqueFilterInput!) {
    googleGroup(where: $where) {
      id
      groupTitle
      role {
        id
        slug
      }
    }
  }
`;

export const useGetGoogleGroup = (id?: string, skip?: boolean) =>
  useQuery<GetGoogleGroupQuery, GetGoogleGroupQueryVariables>(
    GET_GOOGLE_GROUP,
    {
      variables: { where: { id } },
      skip: !id || skip,
    },
  );
